import React from "react";
import { Container, Row, Col } from "react-bootstrap";
import approachStyles from "../styles/Approach.module.css";

import styles from "../styles/App.module.css";

const Approach = () => {
  return (
    <Container className="mb-4">
      <Row className="justify-content-center mb-4">
        <Col md={10} lg={10}>
          <h1 className="mb-4">
            A calm, collaborative process centred on you.
          </h1>

          <h2 className="my-5">Because every person is different</h2>
          <p>
            I provide a calm, supportive space where you feel able to talk
            openly and feel heard without judgment. A humanistic and integrative
            approach, drawing from several therapeutic models to suit the
            individual needs of each person, because each person is different.
            Whether you’re struggling with anxiety, relationship issues, past
            trauma, or simply feeling stuck, our sessions focus on helping you
            understand what’s going on beneath the surface and find a way
            forward, allowing you to reach your authentic self. Together, we’ll
            explore patterns, emotions, and experiences at your own pace,
            building resilience and self-understanding so you can move toward
            greater balance and confidence in yourself.
          </p>
        </Col>
      </Row>

      <Row className="justify-content-center mb-4">
        <Col md={10} lg={10}>
          <h2 className="mb-3">How I work</h2>
          <p>
            <span className={styles.Bolded}>Humanistic foundation</span> –
            Building trust and understanding through genuine connection.
          </p>
          <p>
            <span className={styles.Bolded}>Integrative tools</span> – Drawing
            from Humanistic Counselling, CBT, and EFT to suit your needs.
          </p>
          <p>
            <span className={styles.Bolded}>EMDR-informed practice</span> –
            Helping to process trauma, distressing memories, and anxiety safely.
          </p>

          <p>
            <span className={styles.Bolded}>
              Whether you’re coping with anxiety, loss, low self-esteem, trauma,
              or feeling stuck, therapy can offer perspective and renewed
              balance. The focus is on helping you feel heard, understood, and
              equipped to move forward with confidence.
            </span>
          </p>
          <br />
          <h3>Areas I work with</h3>
          <div className={approachStyles.areasContainer}>
            <ul>
              <li>Anger management</li>
              <li>Anxiety</li>
              <li>Behaviour problems</li>
              <li>Bereavement</li>
              <li>Body dysmorphic disorder (BDD)</li>
              <li>Bullying</li>
              <li>Burn out</li>
              <li>Child counselling</li>
              <li>Childhood anxiety</li>
              <li>Childhood bereavement</li>
              <li>Childhood bullying</li>
              <li>Depression</li>
            </ul>
            <ul>
              <li>Discrimination</li>
              <li>Dissociation</li>
              <li>Domestic abuse</li>
              <li>Drug addiction</li>
              <li>Emotional abuse</li>
              <li>Family issues</li>
              <li>Feeling sad</li>
              <li>Gender dysphoria</li>
              <li>Generalised anxiety disorder (GAD)</li>
              <li>Hearing voices</li>
              <li>Loneliness</li>
              <li>Low self-confidence</li>
            </ul>
            <ul>
              <li>Low self-esteem</li>
              <li>Menopause</li>
              <li>Miscarriage</li>
              <li>Obsessive compulsive disorder (OCD)</li>
              <li>Panic attacks</li>
              <li>Paranoia</li>
              <li>Personality disorders</li>
              <li>Physical abuse</li>
              <li>Post-traumatic stress disorder (PTSD)</li>
              <li>Psychosis</li>
              <li>Redundancy</li>
            </ul>
            <ul>
              <li>Relationship problems</li>
              <li>Seasonal affective disorder (SAD)</li>
              <li>Self-harm</li>
              <li>Separation and divorce</li>
              <li>Separation anxiety</li>
              <li>Sexual abuse</li>
              <li>Stress</li>
              <li>Suicidal thoughts</li>
              <li>Trauma</li>
              <li>Work-related stress</li>
              <li>Young carers</li>
            </ul>
          </div>
        </Col>
      </Row>
    </Container>
  );
};

export default Approach;
